module.exports = __webpack_public_path__ + "static/media/image-fourth-strip.9f8b56a7.svg";